import Vue from 'vue'
import Router from 'vue-router'

import { authGuard } from './authGuard'

import MainLayout from '@/layouts/MainLayout'
import LandingPage from '@/views/LandingPage'
import GitHubCallback from '@/views/GitHubCallback'
import SuccessOrFailure from '@/views/SuccessOrFailure.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '',
      beforeEnter: authGuard,
      component: MainLayout,
      children: [
        {
          path: '',
          component: LandingPage,
          name: 'landing-page'
        },
        {
          path: 'github-callback',
          component: GitHubCallback,
          name: 'github-callback'
        },
        {
          path: 'success-failure',
          component: SuccessOrFailure,
          name: 'success-failure',
          props: true
        }
      ]
    }
  ],
  mode: 'history'
})

export default router
